import React from 'react';

export const RedirectToErrorPage: React.FC = () => {
  throw new Error();
};
